// extracted by mini-css-extract-plugin
export var listWrapper = "lectures-list-module--list-wrapper--3BGLK";
export var list = "lectures-list-module--list--9i9bN";
export var notice = "lectures-list-module--notice--1Pl1c";
export var noticeText = "lectures-list-module--notice-text--p4DkJ";
export var noticeIcon = "lectures-list-module--notice-icon--ZF8-J";